import axios from 'axios'

export const callGet = (url, token, params = {}) => (
  axios.get(`${url}`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
    params,
  })
)

export const callPost = (url, payload, token = '') => {
  const headers = {}
  
  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  return axios.post(`${url}`, payload, {
    headers,
  })
}

export const callPostMultipartFormData = (url, payload, token = '') => {
  const headers = {}
  
  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  return axios.post(`${url}`, payload, {
		headers: {
			"Authorization": `Bearer ${token}`,
			"Content-Type": "multipart/form-data",
		},
	});
}

export const callPatch = (url, payload, token = '') => {
  const headers = {}

  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  return axios.patch(`${url}`, payload, {
    headers,
  })
}


export const callPostForBlob = (url, payload, token = '') => {
  const headers = {}

  if (token) {
    headers.authorization = `Bearer ${token}`
  }
  return axios.post(`${url}`, payload, {
    responseType: 'blob',
    headers,
  })
}

